import React, { useEffect, useState } from 'react';
import { ProjectProps } from "../../../types/IdProps";
import Authorize from '../../../components/AuthComponent/Authorize';
import SaveButton, { SaveButtonProps } from '../../../components/Buttons/SaveButton';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import ButtonBar from '../../../components/Fields/ButtonBar';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import { ApplicationFunctions } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ProjectUserDefinedFieldsModel from '../../../models/ProjectUserDefinedFieldsModel';
import ProjectItemRevisionUserDefinedFieldsModel from '../../../models/ProjectItemRevisionUserDefinedFieldsModel';
import DataService from "../../../services/data.service";
import { ItemIdProps } from '../../../types/IdProps';
import { Result } from '../../../types/Result';
import UserDefinedFieldModel from '../../../models/UserDefinedFieldModel';
import UserDefinedFieldValueModel from '../../../models/UserDefinedFieldValueModel';
import { Col, Row } from 'react-bootstrap';
import SpinnerOverlay from '../../../components/Spinner/SpinnerOverlay';

const Project_tab_UserDefinedFields: React.FC<ProjectProps> = ({ projectId, projectTypeId, refreshDataCounter }) => {
    const [data, setData] = useState<ProjectItemRevisionUserDefinedFieldsModel[]>();
    const [fields, setFields] = useState<UserDefinedFieldModel[]>();
    const [serverErrors, setServerErrors] = useState<Result[]>();
    const [showSpinner, setShowSpinner] = useState(false);
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [projectId]);

    function getTableData() {
        DataService.get<ProjectUserDefinedFieldsModel>('api/v1/ProjectItemRevisions/ByProjectWithUserDefinedFields/' + projectId)
            .then(response => {
                setData(response.projectItemRevisions);
                setFields(response.fields);
            })
            .catch(e => { handleException(e); });
    }

    function SaveChanges() {
        if (data) {
            setShowSpinner(true)
            DataService
                .updateTableData<ProjectItemRevisionUserDefinedFieldsModel>(`api/v1/ProjectItemRevisions/UpdateUserDefinedFields`, data)
                .then(response => {
                    setShowSpinner(false)
                    response.forEach(result => handleResult(result))
                    setServerErrors(response);
                })
                .catch(e => handleException(e));
        }
    }

    function onCellChange(value: any, rowIndex: number, dataProp?: string) {
        if (data && dataProp) {
            dataProp.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    object[propertyName] = value;
                    setData(data.slice());
                }

                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, data[rowIndex]);
        }
    }

    function getUserDefinedField(rowData: ProjectItemRevisionUserDefinedFieldsModel, colInfo: IColInfo): UserDefinedFieldModel | undefined {
        let result

        rowData.userDefinedFieldValues.forEach((value, index) => {
            if (value.userDefinedField && value.userDefinedField.name == colInfo.title)
                result = value.userDefinedField
        })

        return result
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Item Nr', dataProp: 'projectItemRevision.itemRevision.item', dataType: 'item', sort: 'asc' },
        { title: 'Revision', dataProp: 'projectItemRevision.itemRevision.revisionNumber', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Item name', dataProp: 'projectItemRevision.itemRevision.item.name', filterInfo: { filterType: 'Textbox' } },
    ];

    if (fields) {
        fields.forEach((field, index, array) => {
            colInfos.push({
                title: field.name,
                width: 175,
                dataProp: 'userDefinedFieldValues.' + index + '.value',
                editable: true,
                dataType: 'userDefinedField',
                getUserDefinedField: getUserDefinedField,
            })

        })
    }




    const saveButtonProps: SaveButtonProps = {
        onClick: SaveChanges
    }

    if (data && fields) {
        return (
            <>
                <DataTable key='dtProjectItemDetails'
                    name='dtProjectItemDetails'
                    colInfos={colInfos}
                    tableData={data}
                    serverErrors={serverErrors}
                    onCellChange={onCellChange}

                />
                <Row>
                    <Col md='5'>
                        <ButtonBar offset={3}>
                            <Authorize applicationFunction={ApplicationFunctions.EditProjectItemDetailInfo} projectTypeId={projectTypeId}>
                                <SaveButton  {...saveButtonProps} />
                            </Authorize>
                        </ButtonBar>
                    </Col>
                    <Col md='7'>
                        <ButtonBar offset={0}>
                        </ButtonBar>
                    </Col>
                </Row>
                {showSpinner && <SpinnerOverlay />}
            </>
        );
    }

    return null;
}
export default Project_tab_UserDefinedFields;
